<template>
  <div class="news">
    <div class="news-head">
      <div class="news-head-titel">
        {{ newsData.post_title }}
      </div>
      <div class="news-head-date">{{ newsData.post_modified }}</div>
      <div class="news-head-creater">{{ newsData.post_source }}</div>
    </div>
    <div class="newsWrap" id="newsWrap" v-html="newsData.post_content">
    </div>
  </div>
</template>

<script>
export default {
  name: 'news',
  data() {
    return {
      newsData:{}
    }
  },
  created(){
    this.initData();
  },
  components: {
  },
  computed: {
    locale: function () {
      // console.log(this.$i18n.locale)
      return this.$i18n.locale
    }
  },
  mounted(){
  },
  methods: {
    
    initData(){
      var v_this = this;
      let ajaxUrl = 'https://newseditor.gamepoch.com/thinkcmf/data_news.php?post_net=gamepoch.com&id=';
      if(v_this.locale == 'zh'){
        ajaxUrl = 'https://newseditor.gamepoch.com/thinkcmf/data_news.php?post_net=gamepoch.cn&id=';
      }
      $.get(ajaxUrl+v_this.$route.query.index)
      .then(data => {
        v_this.newsData = data[0];
      })
      .catch(function(error) {
        console.log(error);
      });

    }
  }
}

</script>

<style scoped lang="scss">
@media (min-width: 0em) and (max-width:800px) {
  .news-head{
    padding: 80px 30px 0px 30px !important;
  }
  .newsWrap{
    padding: 30px 30px 0px 30px !important;
  }
}

.news{
  background-color: #000;
  padding-top: 82px;
  font-family: "open sans",sans-serif;
}

.news-head{
  width: 100%;
  max-width: 1024px;
  // background-color: #ecf0f1;
  background-color: #2b2b2b;
  margin: 0 auto;
  position: relative;
  padding: 100px 120px 0px 120px;
}
.news-head-titel{
  color: #afafaf;
  font-weight: 600;
  font-size: 35px;
  width: 100%;
}
.news-head-date{
  margin-top: 15px;
  color: #777;
  font-size: 15px;
  line-height: 1.5;
  width: 100%;
}
.news-head-creater{
  color: #777;
  font-size: 15px;
  line-height: 1.5;
  width: 100%;
}
.newsWrap{
  width: 100%;
  max-width: 1024px;
  // background-color: #ecf0f1;
  background-color: #2b2b2b;
  margin: 0 auto;
  position: relative;
  color: #777;
  line-height: 1.5;
  padding: 50px 120px 100px 120px;
}
#newsWrap >>> p{
  font-size: 14px !important;
  margin: 0 0
   10px;
}
#newsWrap >>> b,#newsWrap >>> strong {
    font-weight: 600;
}
.gp-header {
    background: -webkit-gradient(linear, left top, left bottom, color-stop(90%, rgba(0,0,0,1)), to(transparent)) !important;
    background: linear-gradient(180deg, rgba(0,0,0,1) 90%, transparent) !important;
}
</style>



// WEBPACK FOOTER //
// src/views/News.vue